import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
const API_URL = process.env.REACT_APP_API_URL?.replace('/api','') || '';

export default function MemberProfile() {
  const { user, membership, fetchMe } = useAuth();
  const [form, setForm]  = useState({ name: user?.name||'', phone: user?.phone||'', address: user?.address||'', fitness_goal: user?.fitness_goal||'general_fitness', emergency_contact: user?.emergency_contact||'' });
  const [photo, setPhoto] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]    = useState('');
  const [pwForm, setPwForm] = useState({ current_password:'', new_password:'' });
  const [pwMsg, setPwMsg]   = useState('');

  const save = async e => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => fd.append(k, v));
      if (photo) fd.append('photo', photo);
      await axios.put('/auth/profile', fd, { headers:{ 'Content-Type':'multipart/form-data' } });
      await fetchMe(); setMsg('Profile updated!');
    } catch { setMsg('Error saving.'); } finally { setSaving(false); }
  };

  const changePassword = async e => {
    e.preventDefault(); setPwMsg('');
    try { await axios.put('/auth/change-password', pwForm); setPwMsg('Password changed!'); setPwForm({ current_password:'', new_password:'' }); }
    catch (err) { setPwMsg(err.response?.data?.message || 'Error.'); }
  };

  const photoSrc = photo ? URL.createObjectURL(photo) : user?.photo ? `${API_URL}${user.photo}` : null;
  const initials = user?.name?.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2);

  return (
    <div>
      <div className="page-header"><div><h1 className="page-title">My profile</h1><p className="page-sub">Manage your account details</p></div></div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 2fr', gap:18 }}>
        {/* Sidebar info */}
        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          <div className="card" style={{ padding:24, textAlign:'center' }}>
            <div style={{ position:'relative', display:'inline-block', marginBottom:14 }}>
              <div className="avatar" style={{ width:72, height:72, fontSize:24, margin:'0 auto' }}>
                {photoSrc ? <img src={photoSrc} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : initials}
              </div>
              <label style={{ position:'absolute', bottom:0, right:0, width:24, height:24, background:'var(--accent)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', fontSize:12 }}>
                📷<input type="file" accept="image/*" style={{ display:'none' }} onChange={e => setPhoto(e.target.files[0])} />
              </label>
            </div>
            <div style={{ fontSize:16, fontWeight:600 }}>{user?.name}</div>
            <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:4 }}>{user?.email}</div>
          </div>

          {membership && (
            <div className="card" style={{ padding:18 }}>
              <div style={{ fontSize:12, fontWeight:600, color:'var(--text-muted)', marginBottom:10 }}>Current membership</div>
              <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>{membership.plan_name}</div>
              <div style={{ fontSize:12, color:'var(--text-secondary)', marginBottom:8 }}>Expires: {new Date(membership.expiry_date).toLocaleDateString('en-GB')}</div>
              <div style={{ height:4, background:'var(--surface-2)', borderRadius:2 }}>
                <div style={{ height:'100%', borderRadius:2, background: Math.ceil((new Date(membership.expiry_date)-new Date())/86400000) < 7 ? 'var(--warning)' : 'var(--success)', width:`${Math.min(100, Math.max(0, Math.ceil((new Date(membership.expiry_date)-new Date())/86400000)/30*100))}%` }} />
              </div>
            </div>
          )}
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
          {/* Profile form */}
          <div className="card">
            <div className="card-header"><div className="card-title">✏️ Personal details</div></div>
            <form onSubmit={save} style={{ padding:20 }}>
              {msg && <div style={{ marginBottom:12, padding:'9px 14px', borderRadius:'var(--radius)', background:'var(--success-dim)', color:'var(--success)', fontSize:13 }}>{msg}</div>}
              <div className="form-row">
                <div className="form-group"><label className="label">Full name</label><input className="input" value={form.name} onChange={e => setForm(p=>({...p,name:e.target.value}))} /></div>
                <div className="form-group"><label className="label">Phone</label><input className="input" value={form.phone} onChange={e => setForm(p=>({...p,phone:e.target.value}))} /></div>
              </div>
              <div className="form-group"><label className="label">Address</label><input className="input" value={form.address} onChange={e => setForm(p=>({...p,address:e.target.value}))} /></div>
              <div className="form-row">
                <div className="form-group"><label className="label">Fitness goal</label>
                  <select className="select" value={form.fitness_goal} onChange={e => setForm(p=>({...p,fitness_goal:e.target.value}))}>
                    <option value="weight_loss">Weight loss</option><option value="muscle_gain">Muscle gain</option>
                    <option value="endurance">Endurance</option><option value="general_fitness">General fitness</option>
                  </select>
                </div>
                <div className="form-group"><label className="label">Emergency contact</label><input className="input" value={form.emergency_contact} onChange={e => setForm(p=>({...p,emergency_contact:e.target.value}))} /></div>
              </div>
              <button className="btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
            </form>
          </div>

          {/* Change password */}
          <div className="card">
            <div className="card-header"><div className="card-title">🔒 Change password</div></div>
            <form onSubmit={changePassword} style={{ padding:20 }}>
              {pwMsg && <div style={{ marginBottom:12, padding:'9px 14px', borderRadius:'var(--radius)', background: pwMsg.includes('!') ? 'var(--success-dim)' : 'var(--danger-dim)', color: pwMsg.includes('!') ? 'var(--success)' : 'var(--danger)', fontSize:13 }}>{pwMsg}</div>}
              <div className="form-row">
                <div className="form-group"><label className="label">Current password</label><input className="input" type="password" value={pwForm.current_password} onChange={e => setPwForm(p=>({...p,current_password:e.target.value}))} required /></div>
                <div className="form-group"><label className="label">New password</label><input className="input" type="password" value={pwForm.new_password} onChange={e => setPwForm(p=>({...p,new_password:e.target.value}))} required /></div>
              </div>
              <button className="btn-ghost" type="submit">Change password</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
